import _mixin from '../_mixin'

export default {
  name: 'SWelfareCollectionActivity',
  cnName: '福利集合页',
  type: 'activity_other',
  preview: 'https://rescdn-crash.ssjj.cn/website/2025/10/30/9bd6b0759757562f3a0fff269145024c.jpeg',
  // 属性相关
  props: {
    activityId: 'ZHZTEJDNPJUGSO7W3SPOOLG6EY',
    defaultBg: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/10/30/92f2d13257eab5bc493de18247b52365.jpg',
      style: {
        width: '100%',
        height: '2975px'
      }
    },
    btnLottery: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/10/30/a4ec1a9aafc4d455055c81ff3e94d92e.png',
      style: {
        width: '448px',
        height: '124px',
        position: 'absolute',
        top: '1088px',
        right: '',
        bottom: '',
        left: '736px',
        cursor: 'pointer'
      }
    },
    lotteryText1: '抽奖描述小文案抽奖描述小文案抽奖描述小文案抽奖描述小文案抽奖描述小文案',
    lotteryText1Position: '1026px _ _ 50%',
    lotteryTextStyle1: '{"fontSize":"18px","color":"#fff","position":"absolute","transform":"translateX(-50%)"}',
    lotteryText2: '当前可抽奖次数:',
    lotteryText2Position: '1236px _ _ 50%',
    lotteryTextStyle2: '{"fontSize":"16px","color":"#fff","position":"absolute","transform":"translateX(-50%)"}',
    lotteryCountStyle: '{"color":"#70E8F3"}',
    activityList: [
      {
        img: 'https://rescdn-crash.ssjj.cn/website/2025/10/30/1a2010609b022af266bccfafaa1d88fa.png',
        time: '11/10',
        title: '活动文案活动文案',
        status: 0
      },
      {
        img: 'https://rescdn-crash.ssjj.cn/website/2025/10/30/0bf0285b9ea6cb63f00c85f2caa37352.png',
        time: '11/10',
        title: '活动文案活动文案',
        status: 0
      },
      {
        img: 'https://rescdn-crash.ssjj.cn/website/2025/10/30/feda4ac3abc4934b3dcc41d9d97ad0a1.png',
        time: '11/10',
        title: '活动文案活动文案',
        status: 0
      },
      {
        img: 'https://rescdn-crash.ssjj.cn/website/2025/10/30/feda4ac3abc4934b3dcc41d9d97ad0a1.png',
        time: '11/10',
        title: '活动文案活动文案',
        status: 0
      }
    ],
    btnNowJump: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/10/30/d7727332796838e69c63bf80ed4b8bf5.png',
      style: {
        width: '230px',
        height: '64px',
        position: 'absolute',
        top: '169px',
        right: '',
        bottom: '',
        left: '690px',
        cursor: 'pointer'
      }
    },
    btnExpire: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/10/30/50e18c1a105049b8936aa1bbeecd6634.png',
      style: {
        width: '230px',
        height: '64px',
        position: 'absolute',
        top: '169px',
        right: '',
        bottom: '',
        left: '690px'
      }
    },
    btnWaiting: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/10/30/98af32050e5efa14b849fc26757247c9.png',
      style: {
        width: '230px',
        height: '64px',
        position: 'absolute',
        top: '169px',
        right: '',
        bottom: '',
        left: '690px'
      }
    },
    trackColor: '#7d4f83',
    thumbColor: '#792C81'
  },
  propsDesc: [
    {
      target: 'activityId',
      label: '抽奖Id'
    },
    {
      target: 'defaultBg',
      label: '背景图',
      formType: 'image'
    },
    {
      target: 'btnLottery',
      label: '抽奖按钮图片',
      formType: 'image'
    },
    {
      target: 'lotteryText1',
      label: '抽奖文本1'
    },
    {
      target: 'lotteryText1Position',
      label: '抽奖文本1位置',
      formType: 'position'
    },
    {
      target: 'lotteryTextStyle1',
      label: '抽奖文本1样式',
      formType: 'textarea'
    },
    {
      target: 'lotteryText2',
      label: '抽奖文本2'
    },
    {
      target: 'lotteryText2Position',
      label: '抽奖文本2位置',
      formType: 'position'
    },
    {
      target: 'lotteryTextStyle2',
      label: '抽奖文本2样式',
      formType: 'textarea'
    },
    {
      target: 'lotteryCountStyle',
      label: '抽奖次数样式',
      formType: 'textarea'
    },
    {
      target: 'activityList',
      label: '活动列表',
      formType: 'list',
      listConfig: [
        {
          title: '底图',
          target: 'img'
        },
        {
          title: '时间',
          target: 'time'
        },
        {
          title: '文案',
          target: 'title'
        },
        {
          title: '初始状态',
          target: 'status'
        }
      ]
    },
    {
      target: 'btnNowJump',
      label: '立即前往按钮',
      formType: 'image'
    },
    {
      target: 'btnExpire',
      label: '已下线按钮',
      formType: 'image'
    },
    {
      target: 'btnWaiting',
      label: '敬请期待按钮',
      formType: 'image'
    },
    {
      target: 'trackColor',
      label: '滚动条轨道颜色',
      formType: 'color'
    },
    {
      target: 'thumbColor',
      label: '滚动条滑块颜色',
      formType: 'color'
    }
  ],

  // 样式相关
  styles: {
    ..._mixin.styles
  },
  stylesDesc: [
    ..._mixin.stylesDesc
  ],

  // 事件相关
  events: {
  // click: () => {} 无需配置
  },
  eventsList: [
  // eventTpl 无需配置
  ],
  eventsDesc: [
    ..._mixin.eventsDesc
  ],

  methods: [
    ..._mixin.methods
  ],
  children: [
  // {
  //   id: genId() + '_BaseGroup_0',
  //   ...BaseGroup
  // },
  // {
  //   id: genId() + '_BaseGroup_1',
  //   ...BaseGroup
  // }
  ]
}
